import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import { Hero } from '@xo-union/tk-ui-typography';
import GdsUiState from '~/glm/models/gds/gds-ui-state';
import EventCollection from '~/glm/models/gds/event-collection';
import EventSelector from '~/glm/components/guest-list/header/glm-header/event-selector';
import AnalyticsStore from '~/glm/models/analytics-store';
import GuestListStore from '~/glm/models/guest-list-store';
import GdsHouseholdCollection from '~/glm/models/gds/gds-household-collection';
import OverviewHeader from '~/glm/components/guest-list/header/overview-header';
import SelectedEventHeader from '~/glm/components/guest-list/header/selected-event-header';
import UserStore from '~/glm/models/user-store';
import Tasks from './tasks/tasks';
import styles from './glm-header.scss';

@observer
class GLMHeader extends React.Component {
  static propTypes = {
    gdsUiState: PropTypes.instanceOf(GdsUiState).isRequired,
    gdsHouseholds: PropTypes.instanceOf(GdsHouseholdCollection),
    gdsEvents: PropTypes.instanceOf(EventCollection).isRequired,
    analyticsStore: PropTypes.instanceOf(AnalyticsStore).isRequired,
    guestListStore: PropTypes.instanceOf(GuestListStore).isRequired,
    userStore: PropTypes.instanceOf(UserStore).isRequired,
  };

  render() {
    const { gdsUiState, gdsEvents, analyticsStore, guestListStore, gdsHouseholds, userStore } = this.props;

    const rootClassName = classNames(styles.glmHeader, styles.glmHeaderResponsive);
    const showZeroState = !(gdsUiState?.selectedEvent && gdsUiState.selectedEvent.invitedHouseholds.length);

    return (
      <>
        <div className={rootClassName}>
          <Hero className={styles.title} size="md" as="h1">
            Guest list
          </Hero>
          <Tasks
            hasWWS={userStore.hasWWS}
            gdsEvents={gdsEvents}
            guestListStore={guestListStore}
            analyticsStore={analyticsStore}
          />
        </div>
        <EventSelector
          gdsEvents={gdsEvents}
          gdsUiState={gdsUiState}
          analyticsStore={analyticsStore}
          guestListStore={guestListStore}
          userStore={userStore}
        />
        <div className={styles.headerContainer}>
          <OverviewHeader
            events={gdsEvents}
            gdsUiState={gdsUiState}
            gdsHouseholds={gdsHouseholds}
            analyticsStore={analyticsStore}
            guestListStore={guestListStore}
            userStore={userStore}
            showZeroState={showZeroState}
          />
          <SelectedEventHeader
            gdsUiState={gdsUiState}
            analyticsStore={analyticsStore}
            gdsHouseholds={gdsHouseholds}
            gdsEvents={gdsEvents}
            guestListStore={guestListStore}
            userStore={userStore}
          />
        </div>
      </>
    );
  }
}

export default GLMHeader;
